module.exports = __webpack_public_path__ + "img/drug-33.33812f7f.png";